// removed by extract-text-webpack-plugin
module.exports = {"checkAll":"fullTab__checkAll___3ANAg","hrLine":"fullTab__hrLine___2LPVl","pagination":"fullTab__pagination___2net3","tags":"fullTab__tags___2wfET"};


//////////////////
// WEBPACK FOOTER
// ./components/Scoreboard/fullTab.scss
// module id = ./components/Scoreboard/fullTab.scss
// module chunks = 5